import React, { useCallback, useEffect } from 'react'
import { Segmented } from 'antd'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router'
import assignmentSelectors from '../../../../../../store/selectors/assignment.selectors'
import { isMba } from '../../../../../../utils/assignment.helper'
import useQueryParam from '../../../../../../hooks/useQueryParam'
import useQueryParamSetter from '../../../../../../hooks/useQueryParamSetter'
import { TEST_SET_ONLY_PARAM } from '../../../../../../constants/query-params'
import useRubricContext from '../../../../../../hooks/useRubricContext'

const TEST_SET_OPTIONS = [
    { label: 'All Submissions', value: 'all-submissions' },
    { label: 'Test Set', value: 'test-set' },
]

const TestSetToggle = () => {
    const assignmentType = useSelector(assignmentSelectors.type)
    const { layerId: questionRubricId } = useParams()
    const setQueryParam = useQueryParamSetter()
    const testSetOnlyParam = useQueryParam(TEST_SET_ONLY_PARAM)
    const testSetOnly = testSetOnlyParam === 'true'

    const { questionRubric, allRubricsAreTrained, isFetching } = useRubricContext()

    // Only show for fully trained models/questionRubrics, not for MBA
    const shouldShowTestSetToggle = useCallback(() => {
        if (isMba(assignmentType)) return false
        if (isFetching) return false

        if (questionRubricId === 'all') {
            // For "all" view, check if all questionRubrics are trained
            return allRubricsAreTrained
        } else {
            // For individual questionRubric view, check if it's trained
            return questionRubric?.lastTrained
        }
    }, [assignmentType, isFetching, questionRubricId, questionRubric, allRubricsAreTrained])

    const handleTestSetChange = value =>
        setQueryParam({ [TEST_SET_ONLY_PARAM]: value === 'test-set' ? 'true' : 'false' })

    useEffect(() => {
        if (isFetching) return

        if (shouldShowTestSetToggle() && !testSetOnlyParam) {
            setQueryParam({ [TEST_SET_ONLY_PARAM]: 'true' })
        }
    }, [isFetching, testSetOnlyParam, setQueryParam, shouldShowTestSetToggle])

    if (!shouldShowTestSetToggle()) {
        return null
    }

    return (
        <Segmented
            options={TEST_SET_OPTIONS}
            value={testSetOnly ? 'test-set' : 'all-submissions'}
            onChange={handleTestSetChange}
        />
    )
}

export default TestSetToggle
